import { getRequestFormV2DefaultValues } from "@RequestFormV2/utils/getDefaultFormValues";
import { prepareDraftPayload } from "@RequestFormV2/utils/prepareDraftPayload";

export function buildCreateDraftPayload(location: string) {
  const defaults = getRequestFormV2DefaultValues();

  return prepareDraftPayload({
    ...defaults,
    organizational: {
      ...defaults.organizational,
      location,
    },
  });
}
